export const PASSWORD_REGEX = /^.{8,}$/;
export const DOMAIN_REGEX = /^(?!:\/\/)([a-zA-Z0-9-_]+(\.[a-zA-Z0-9-_]+)+.*)$/;
